import React from 'react';
import { DialogContent, Typography } from '@mui/material';

/**
 * Reusable error display component for modals
 * Handles both string and array error responses consistently
 *
 * @param {string|array} errorResponse - Error message(s) to display
 * @param {object} sx - Additional styling (optional)
 */
export default function ModalErrorDisplay({ errorResponse, sx = {} }) {
  if (!errorResponse) {
    return null;
  }

  const defaultSx = {
    p: 3,
    pt: 0,
    ...sx,
  };

  return (
    <DialogContent sx={defaultSx}>
      {Array.isArray(errorResponse) ? (
        errorResponse.map((item, index) => (
          <Typography key={index} color="error">
            {item}
          </Typography>
        ))
      ) : (
        <Typography color="error">{errorResponse}</Typography>
      )}
    </DialogContent>
  );
}